"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tabs = _interopRequireDefault(require("./Tabs"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class TabbedContainer extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: props.activeTab && !Number.isNaN(props.activeTab) ? props.activeTab : 0
    };
    this.handleSetActiveTab = this.handleSetActiveTab.bind(this);
  }
  handleSetActiveTab(ind) {
    const {
      tabList,
      setActiveTab
    } = this.props;
    let newActiveTab = 0;

    // Ensure active tab index is within the range of tabs else set to first tab
    if (ind > -1 && ind <= tabList.length - 1) {
      newActiveTab = ind;
      setActiveTab(ind);
    }
    this.setState({
      activeTab: newActiveTab
    });
  }
  render() {
    const {
      tabList,
      useButtons
    } = this.props;
    const {
      activeTab
    } = this.state;
    const activeTabContent = tabList[activeTab].content;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Tabs.default, {
      active: activeTab,
      useButtons: useButtons,
      tabList: tabList,
      setActiveTab: this.handleSetActiveTab.bind()
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "tabs--content"
    }, activeTabContent));
  }
}
TabbedContainer.propTypes = {
  className: _propTypes.default.string,
  activeTab: _propTypes.default.number,
  tabList: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    iconActive: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
    iconInactive: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
    content: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
  })).isRequired,
  setActiveTab: _propTypes.default.func,
  useButtons: _propTypes.default.bool
};
TabbedContainer.defaultProps = {
  className: '',
  activeTab: 0,
  setActiveTab: () => {},
  useButtons: false
};
var _default = exports.default = TabbedContainer;
//# sourceMappingURL=TabbedContainer.js.map